import React, { createContext, useEffect, useState } from 'react';
import { getBMSSettings, getHomeSettings, getLegalSettings, getMaintenanceStatus, getMetaSettings, getMonthlyPricesSettings, getSiteSettings, getZendeskSettings } from '../services/settings.service';

import { IntlProvider } from 'react-intl';
import Loading from '../../ui/02_molecules/loading/Loading';
import CONFIG from '../config';
import STORAGE from '../constants/storage.constants';
import { getCampaigns } from '../services/campaigns.service';
import { getCars } from '../services/cars.service';
import { getDealer } from '../services/dealers.service';
import { getPages } from '../services/pages.service';

import { getHeaderSliders } from '../services/headerSliders.service';
import { getTranslations } from '../services/translations.service';

export const KiaContext = createContext({});

export const KiaContextProvider = (props) => {
  const { selectedLanguage, children, locales, country } = props;

  const [lang, setLang] = useState(selectedLanguage);
  const [messages, setMessages] = useState({});
  const [loading, setLoading] = useState(true);
  const [openMenu, setOpenMenu] = useState(false);
  const [mobile, setMobile] = useState(true);
  const [cars, setCars] = useState([]);

  const [pages, setPages] = useState([]);
  const [campaigns, setCampaigns] = useState(null);
  const [currentLocale, setCurrentLocale] = useState(null);
  const [showZendesk, setShowZendesk] = useState(false);
  const [bms, setBms] = useState(false);
  const [bmsExtended, setBmsExtended] = useState(false);
  const [legal, setLegal] = useState(null);
  const [home, setHome] = useState(null);
  const [meta, setMeta] = useState(null);
  const [representativePopup, setRepresentativePopup] = useState('');
  const [dealer, setDealer] = useState(null);
  const [showMonthlyPrices, setshowMonthlyPrices] = useState(false);
  const [showEasyMoveLegalBanner, setShowEasyMoveLegalBanner] = useState(true);
  const [hideToggle, setHideToggle] = useState(false);
  const [carouselData, setCarouselData] = useState([]);

  const isB2c = Number(CONFIG.IS_B2C) === 1;

  const getDealerData = async () => {
    const _dealer = sessionStorage.getItem(STORAGE.dealer);

    const dealer = await getDealer(_dealer);

    setDealer(dealer);
  };

  const clearDealer = () => {
    setDealer(null);
    sessionStorage.removeItem(STORAGE.dealer);
  };

  const getMessages = async (lang) => {
    const _messages = await getTranslations(lang);

    setMessages(_messages);
  };



  const onResize = () => {
    setMobile(window.matchMedia(`(max-width: ${CONFIG.MOBILE_WIDTH}px)`).matches);
  };

  const getCarsOverview = async () => {
    const cars = await getCars(lang);
    const mp = await getMonthlyPricesSettings();

    if (CONFIG.DEBUG) { console.log('cars overview', cars); }

    const extendedCars = cars.map(car => {
      let engine = car.engine.map(engine => {
        return {
          id: engine.id,
          title: engine.title,
          type: engine.type,
          weight: engine.weight,
          car_id: engine.car_id,
          power: engine.power,
          fuel_consumption: engine.fuel_consumption,
          co_two_emissions: engine.co_two_emissions,
          price: engine.price,
          price_discount: engine.price_discount,
          price_extra_advantage_label: engine.price_extra_advantage_label,
          price_extra_advantage: engine.price_extra_advantage,
          price_bonus: engine.price_bonus,
          price_net: engine.price_net,
          price_trade_bonus: engine.price_trade_bonus,
          recycle_bonus: engine.recycle_bonus,
          price_motor_show: engine.price_motor_show,
          is_exposed_car: engine.is_exposed_car[lang],
          description: engine.description,
          price_calculator: engine.price_calculator,
          action_valid_to: engine.action_valid_to,
          promo_information: engine.promo_information,
          image: engine.image,
          highlight: engine.highlight,
          special_series_highlight: engine.special_series_highlight,
          range: engine.range,
          car_usp_id: engine.car_usp_id,
          inspire: engine.inspire,
          style: engine.style,
          badge: engine.badge,
          show_new_logo: engine.show_new_logo,
          show_new_logo_in_trim: engine.show_new_logo_in_trim,
          easymove: {
            price: engine?.easymove || null,
            amount_to_finance: engine?.amount_loan || null,
            amount_deposit: engine?.amount_deposit || null,
            amount_cash: engine?.amount_cash || null,
            amount_jkp: engine?.amount_jkp || null,
            amount_intrest: engine?.annual_debit_interest?.[lang] || null,
            amount_term: engine?.amount_term || null,
            amount_last_payment: engine?.amount_last_payment || null,
            amount_total: engine?.amount_total || null,
            is_electrical: engine?.type === 'ev' || false
          },
          kia_lease: {
            price: engine?.kia_lease || null,
            co_two_emissions: engine?.kia_lease_co_two_emissions?.[lang] || null,
            duration: engine?.kia_lease_duration?.[lang] || null,
            fuel_consumption: engine?.kia_lease_fuel_consumption?.[lang] || null,
            ind_fisc_value: engine?.kia_lease_ind_fisc_value?.[lang] || null,
            km: engine?.kia_lease_km?.[lang] || null,
            start_date: engine?.kia_lease_start_date?.[lang] || null,
            tco: engine?.kia_lease_tco?.[lang] || null,
            is_electrical: engine?.type === 'ev' || false
          },
          financial_renting: {
            price: engine?.financial_renting || null,
            co_two_emissions: engine?.financial_renting_co_two_emissions?.[lang] || null,
            down_payment: engine?.financial_renting_down_payment?.[lang] || null,
            duration: engine?.financial_renting_duration?.[lang] || null,
            fuel_consumption: engine?.financial_renting_fuel_consumption?.[lang] || null,
            invoiced_amount: engine?.financial_renting_invoiced_amount?.[lang] || null,
            purchase_option_percentage: engine?.financial_renting_purchase_option_percentage?.[lang] || null,
            valid_date: engine?.financial_renting_valid_date?.[lang] || null,
            is_electrical: engine?.type === 'ev' || false
          },
          kia_private_lease: {
            price: engine?.kia_private_lease || null,
            km: engine?.kia_private_lease_km?.[lang] || null,
            duration: engine?.kia_private_lease_duration?.[lang] || null,
            start_date: engine?.kia_private_lease_start_date?.[lang] || null,
            fuel_consumption: engine?.kia_private_lease_fuel_consumption?.[lang] || null,
            co_two_emissions: engine?.kia_private_lease_co_two_emissions?.[lang] || null,
            is_electrical: engine?.type === 'ev' || false
          },
          status: engine?.status === true
        }
      }).filter(engine => engine.status === true)

      let exposedCar = engine.find(e => e.is_exposed_car) || null;

      if (exposedCar) {
        return {
          ...car,
          engine,
          easymove: exposedCar.easymove,
          kia_lease: exposedCar.kia_lease,
          financial_renting: exposedCar.financial_renting
        }
      }

      return {
        ...car,
        engine,
        easymove: null,
        kia_lease: null,
        financial_renting: null
      }
    })
    setCars(extendedCars);
    setshowMonthlyPrices(mp.status === '1');
  }

  const getPagesOverview = async () => {
    const pages = await getPages(lang);

    if (CONFIG.DEBUG) { console.log('pages overview', pages); }

    setPages(pages);
  };

  const getCampaignsOverview = async () => {
    const _campaigns = await getCampaigns(selectedLanguage);

    if (CONFIG.DEBUG) { console.log('campaigns overview', _campaigns); }

    setCampaigns(_campaigns);
  };

  const getCarouselData = async () => {
    try {
      const data = await getHeaderSliders(lang);
      if (CONFIG.DEBUG) { console.log('carousel data', data); }

      const activeItems = data.filter(item => item.status === 1);
      setCarouselData(activeItems);

    } catch (err) {
      console.error('Error fetching carousel data:', err);
      setCarouselData([]);
    }
  };

  const getMeta = async (locale) => {
    const settingsResponse = await getSiteSettings(locale);
    const metaResponse = await getMetaSettings(locale);

    setMeta({
      site_name: settingsResponse.site_name,
      meta_title: metaResponse.title,
      meta_description: metaResponse.description,
    });

    const popup = settingsResponse?.representative_popup;
    if (typeof popup === 'string') {
      setRepresentativePopup(popup);
    } else if (popup && typeof popup === 'object') {
      setRepresentativePopup(popup[locale] || popup[lang] || '');
    } else {
      setRepresentativePopup('');
    }
  };


  const getBMS = async () => {
    const data = await getBMSSettings(lang);

    if (data.status === 'activate_bms') {
      setBms(true);
    }
    else if (data.status === 'activate_bms_extended') {
      setBmsExtended(true);
    }
  };


  const getLegal = async () => {
    const data = await getLegalSettings(lang);

    setLegal(data);
  };

  const getHome = async () => {
    const data = await getHomeSettings(lang)
    setHome(data)
  };

  const getData = async () => {
    getCarsOverview();
    getCampaignsOverview();
    getPagesOverview();
    getCarouselData();
  };

  const getStatus = async () => {
    const data = await getMaintenanceStatus(lang);
    setHideToggle(data === 1);
  };

  const setupZendesk = async () => {
    const settings = await getZendeskSettings();

    if (settings.status !== '1') {
      if (CONFIG.DEBUG) { console.log('Zendesk disabled'); }
      return;
    }
    if (CONFIG.DEBUG) { console.log('Zendesk enabled'); }

    if (document.querySelector('#ze-snippet')) {
      setShowZendesk(true);
      return;
    }

    const script = document.createElement('script');
    script.id = 'ze-snippet';
    script.onload = onZendeskLoaded;
    script.src = 'https://static.zdassets.com/ekr/snippet.js?key=web_widget/kiabelgiumsupport.zendesk.com';

    document.head.appendChild(script);
  };

  const hideZendeskWidget = () => {
    // hide default chat widget
    try {
      window.zE('webWidget', 'hide');
    } catch (e) {
      if (CONFIG.DEBUG) { console.warn('Zendesk not available'); }
    }
  }

  const onZendeskLoaded = () => {
    setShowZendesk(true);
    hideZendeskWidget();
  }

  const setupCookieScript = (locale) => {
    if (!locale) return;

    // Determine domain script ID based on locale
    let domainScriptId;

    // Fallback: if cookieID is not available, determine from locale string
    if (!domainScriptId) {
      if (locale.locale === 'fr-lu') {
        // OneTrust Cookies Consent Notice for kia-showroom.lu
        domainScriptId = '01995274-bfdd-7e8c-af2e-a42fd7883b26';
      } else if (locale.locale === 'nl-be' || locale.slug === 'nl') {
        // OneTrust Cookies Consent Notice for kia-showroom.be/nl
        domainScriptId = '019a9c51-5d65-74f5-972e-674c091d99cc';
      } else if (locale.locale === 'fr-be' || locale.slug === 'fr') {
        // OneTrust Cookies Consent Notice for kia-showroom.be/fr
        domainScriptId = '019a9c4d-5238-764c-b6a4-a1729535b23c';
      } else {
        // Default to FR if locale not recognized
        domainScriptId = '019a9c4d-5238-764c-b6a4-a1729535b23c';
      }
    }

    // Remove existing OneTrust scripts
    const existingScripts = document.querySelectorAll('#script-cookiebar, script[data-domain-script]');
    existingScripts.forEach(script => script.remove());

    // Create and inject OneTrust script into head
    // OneTrust Cookies Consent Notice start
    const script = document.createElement('script');
    script.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
    script.type = 'text/javascript';
    script.charset = 'UTF-8';
    script.setAttribute('data-domain-script', domainScriptId);
    script.id = 'script-cookiebar';

    // Create OptanonWrapper function script
    const wrapperScript = document.createElement('script');
    wrapperScript.type = 'text/javascript';
    wrapperScript.textContent = 'function OptanonWrapper() { }';

    // Inject scripts into head
    console.log('CONFIG.APP_ENV', CONFIG.APP_ENV)
    if (!['development', 'local', 'localhost', 'staging'].includes(CONFIG.APP_ENV)) {
      const head = document.head || document.getElementsByTagName('head')[0];
      head.appendChild(script);
      head.appendChild(wrapperScript);
      // OneTrust Cookies Consent Notice end
    }
  };

  useEffect(() => {
    if (!cars.length) { return; }
    if (!campaigns) { return; }


  }, [cars, campaigns]);

  useEffect(() => {
    hideZendeskWidget();

    // localize chat widget
    try {
      if (CONFIG.DEBUG) { console.log('Zendesk set to', currentLocale.locale); }
      window.zE('webWidget', 'setLocale', currentLocale.locale);
    } catch (e) {
      if (CONFIG.DEBUG) { console.warn('Zendesk not available'); }
    }
  }, [window.zE, currentLocale])

  useEffect(() => {
    if (!lang) { return; }
    if (!Object.keys(messages).length) { return; }
    if (!cars.length) { return; }

    if (!meta) { return; }
    // if (!carouselData.length) { return; }

    setLoading(false);
  }, [lang, messages, cars, meta, carouselData]);

  useEffect(() => {
    setLang(selectedLanguage);
    getMessages(selectedLanguage);

    const locale = locales.find(({ locale }) => locale === selectedLanguage);
    setCurrentLocale(locale);

    getMeta(locale.name);

    // disable cookie check in configurator (iframe)
    // const isConfigurator = window.location.href.indexOf('/configurator/') >= 0;
    // if (!isConfigurator) {
    //   setupCookieScript(locale);
    // }

    getData();

  }, [selectedLanguage]);

  useEffect(() => {
    window.addEventListener('resize', onResize);

    getDealerData();
    setupZendesk();
    getBMS();

    getLegal();
    getHome();
    getStatus();

    setMobile(window.matchMedia(`(max-width: ${CONFIG.MOBILE_WIDTH}px)`).matches);

    return () => {
      window.removeEventListener('resize', onResize);
    }
  }, []);

  const store = {
    loading: { get: loading, set: setLoading },
    language: { locale: lang, set: setLang },
    openMenu: { get: openMenu, set: setOpenMenu },
    mobile,
    cars,

    pages,
    currentLocale,
    showZendesk,
    hideZendeskWidget,
    bms,
    bmsExtended,
    legal,
    locales,
    prefix: currentLocale && locales.length > 1 ? `/${currentLocale.slug}` : '',
    meta,
    representativePopup,
    dealer,
    clearDealer,
    showMonthlyPrices,
    showEasyMoveLegalBanner,
    setShowEasyMoveLegalBanner,
    isB2c,
    otherPlatformUrl: country.other_platform_url,
    home,
    hideToggle,
    country,
    showPromo: bms && isB2c && true, // show promo only for B2C, manual override via true / false
    setupCookieScript,
    carouselData,
  };

  return (
    <KiaContext.Provider value={store}>
      <IntlProvider messages={messages} locale={selectedLanguage}>
        {loading ? <Loading page /> : children}
      </IntlProvider>
    </KiaContext.Provider>
  );
}
